import { createSlice } from "@reduxjs/toolkit";

const initialState = { 
  selectedTab : "today",
  data:[]
};

const appointmentReducer = createSlice({
  name: "appointmentReducer",
  initialState,
  reducers: {
    setSelectedTab(state,action){
      state.selectedTab = action.payload;
    },
    setAppData(state,action){
      state.data = action.payload;
    },
  },
});
export const { setSelectedTab,setAppData } = appointmentReducer.actions;
export default appointmentReducer.reducer;
